import { Box, IconButton, Menu, MenuItem } from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'
import { MoreHorizontal } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { useReactToPrint } from 'react-to-print'
import { pageStyle } from '../common/report-styles'
import { CarbonFootprintReport } from './CarbonFootprintReport'

type Props = {
  projectName: string
}

export function CarbonFootprintMenu({
  projectName,
}: Props): React.ReactElement {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null)
  const printableComponentRef = useRef<HTMLDivElement>(null)
  const { t } = useTranslation()

  const [render, setRender] = useState(false)
  const onBeforeGetContentResolve = useRef<(value: unknown) => void>()

  const handleOnBeforeGetContent = () =>
    new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve
      setRender(true)
    })

  useEffect(() => {
    if (render && onBeforeGetContentResolve.current) {
      void onBeforeGetContentResolve.current(true)
    }
  }, [render, onBeforeGetContentResolve])

  const handlePrint = useReactToPrint({
    content: () => printableComponentRef.current,
    documentTitle: `${projectName}_${t('carbonFootprint.title')}`,
    pageStyle,
    onBeforeGetContent: handleOnBeforeGetContent,
    onAfterPrint: () => setRender(false),
  })

  return (
    <Box>
      <IconButton
        id="open-costs-menu-button"
        onClick={(event) => setMenuAnchorEl(event.currentTarget)}
      >
        <MoreHorizontal />
      </IconButton>

      <Menu
        anchorEl={menuAnchorEl}
        keepMounted
        open={Boolean(menuAnchorEl)}
        onClose={() => setMenuAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setMenuAnchorEl(null)
            if (handlePrint && printableComponentRef) {
              handlePrint()
            }
          }}
        >
          {t('common.print')}
        </MenuItem>
      </Menu>
      <div style={{ display: 'none' }}>
        {render && <CarbonFootprintReport ref={printableComponentRef} />}
      </div>
    </Box>
  )
}
